import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { ObjectSharing, ObjectSharingParam } from '../../object-sharing/object-sharing.model';

export enum DeviceSharingActionTypes {
  GetDeviceSharingList = '[DeviceSharing] Get DeviceSharingList',
  LoadDeviceSharingList = '[DeviceSharing] Load DeviceSharingList',
  AddDeviceSharing = '[DeviceSharing] Add DeviceSharing',
  UpdateDeviceSharing = '[DeviceSharing] Update DeviceSharing',
  DeleteDeviceSharing = '[DeviceSharing] Delete DeviceSharing',
  GetDeviceSharingListFail = '[DeviceSharing] Get DeviceSharingList Fail'
}

export class GetDeviceSharingList implements Action {
  readonly type = DeviceSharingActionTypes.GetDeviceSharingList;
  constructor(public payload: any = null) {}
}

export class LoadDeviceSharingList implements Action {
  readonly type = DeviceSharingActionTypes.LoadDeviceSharingList;

  constructor(public payload: ObjectSharing[]) {}
}

export class AddDeviceSharing implements Action {
  readonly type = DeviceSharingActionTypes.AddDeviceSharing;

  constructor(public payload: ObjectSharingParam) {}
}

export class UpdateDeviceSharing implements Action {
  readonly type = DeviceSharingActionTypes.UpdateDeviceSharing;

  constructor(public payload: ObjectSharingParam) {}
}

export class DeleteDeviceSharing implements Action {
  readonly type = DeviceSharingActionTypes.DeleteDeviceSharing;

  constructor(public payload: ObjectSharingParam) {}
}

export class GetDeviceSharingListFail implements Action {
  readonly type = DeviceSharingActionTypes.GetDeviceSharingListFail;
}

export type DeviceSharingActions =
 GetDeviceSharingList
 | LoadDeviceSharingList
 | AddDeviceSharing
 | UpdateDeviceSharing
 | DeleteDeviceSharing
 | GetDeviceSharingListFail;
